import { Column } from "primereact/column";
import { DataTable, DataTableSelectionMultipleChangeEvent } from "primereact/datatable";
import { useCallback } from "react";
import {
	dataTableClass,
	emptyMessageClass,
} from "@features/multiple-selection-data-table/multiple-selection-data-table.styles";
import { MultipleSelectionDataTableProps } from "@features/multiple-selection-data-table/multiple-selection-data-table.types";
import { useTranslation } from "@i18n/hooks";

export const MultipleSelectionDataTable = ({
	selectedUserIds,
	values,
	onSelectionChange,
}: MultipleSelectionDataTableProps) => {
	const { t } = useTranslation("common");
	const handleSelection = useCallback(
		(event: DataTableSelectionMultipleChangeEvent<any>) => {
			onSelectionChange(event);
		},
		[onSelectionChange],
	);

	const selectedUsers = selectedUserIds?.map((id) => {
		return { node: { id: id } };
	});

	return (
		<DataTable
			emptyMessage={
				<div className="flex justify-content-center align-items-center">
					<div className={emptyMessageClass}>{t("user.noUserFound")}</div>
				</div>
			}
			className={dataTableClass}
			selectionMode="multiple"
			selection={selectedUsers}
			dataKey="node.id"
			onSelectionChange={handleSelection}
			metaKeySelection={false}
			value={values ?? []}
		>
			<Column header={t("table.name")} field="node.name" />
			<Column header={t("table.email")} field="node.email" />
			<Column
				header={t("table.activated")}
				body={(user) => {
					return user?.node?.activated ? t("user.activated") : t("user.notActivated");
				}}
			/>
		</DataTable>
	);
};
